// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 1509649408
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { Contract } from './models/contract/contract';
import { ContractSummary } from './models/nonentity/contractsummary';
import { PayeeContractDetail } from './models/contract/payeecontractdetail';
import { PayeeSummary } from './models/contract/payeesummary';
import { Contact } from './models/contract/contact';
import { Document } from './models/contract/document';
import { BlobResult } from './models/common/blobresult';
import { UploadObject } from '../shared/models/uploadobject';
import { ProcedureSummary } from './models/nonentity/proceduresummary';
import { FacilitySummary } from './models/nonentity/facilitysummary';
import { ProviderSummary } from './models/nonentity/providersummary';
import { AnesthesiaSummary } from './models/nonentity/anesthesiasummary';
import { ProviderGroupSummary } from './models/providergroup/providergroupsummary';

export interface getAllContracts_Filter {
  name: string;
  statuses: number[];
  holderTypeId: number;
  executionDate: string;
  contractTypeId: number;
}

export interface getContractPayees_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getPayeesByContractId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getContractById_Filter {
  includeChildren: boolean;
}

export interface getProceduresByContractId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getFacilitiesByContractId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getProvidersByContractId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getAnesthesiasByContractId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getProviderGroupsByContractId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

@Injectable({
  providedIn: 'root',
})
export class ContractsApiService {
  constructor(protected http: HttpClient) {}

  getAllContracts(
    criteria?: SmartListCriteria,
    queryParams?: Partial<getAllContracts_Filter>
  ): Observable<SmartListResult<Contract>> {
    let url = environment.chiliSauceApiRoot + `/api/Contracts`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<Contract>>(url, { params: params });
  }

  addContract(newContract: Contract): Observable<Contract> {
    const url = environment.chiliSauceApiRoot + `/api/Contracts`;
    return this.http.post<Contract>(url, newContract);
  }

  findContracts(
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<ContractSummary>> {
    let url = environment.chiliSauceApiRoot + `/api/Contracts/find`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<ContractSummary>>(url);
  }

  getPayeeContractDetailsById(
    payeeGuid: string,
    contractGuid: string
  ): Observable<PayeeContractDetail> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Contracts/${contractGuid}/payees/${payeeGuid}/contractdetails`;
    return this.http.get<PayeeContractDetail>(url);
  }

  getContractPayees(
    contractGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getContractPayees_Filter>
  ): Observable<SmartListResult<PayeeSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Contracts/${contractGuid}/contractpayees`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<PayeeSummary>>(url, {
      params: params,
    });
  }

  getPayeesByContractId(
    contractGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getPayeesByContractId_Filter>
  ): Observable<SmartListResult<PayeeSummary>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Contracts/${contractGuid}/payees`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<PayeeSummary>>(url, {
      params: params,
    });
  }

  updatePayeesForContract(
    contractId: string,
    payeeSummaries: PayeeSummary[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Contracts/${contractId}/payees`;
    return this.http.put<any>(url, payeeSummaries);
  }

  getContractById(
    contractGuid: string,
    queryParams?: Partial<getContractById_Filter>
  ): Observable<Contract> {
    const url =
      environment.chiliSauceApiRoot + `/api/Contracts/${contractGuid}`;
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<Contract>(url, { params: params });
  }

  updateContract(contract: Contract, contractGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Contracts/${contractGuid}`;
    return this.http.put<any>(url, contract);
  }

  deleteContract(contractGuid: string): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Contracts/${contractGuid}`;
    return this.http.delete(url);
  }

  getContactsByContractId(ContractGuid: string): Observable<Contact[]> {
    const url =
      environment.chiliSauceApiRoot + `/api/Contracts/${ContractGuid}/contacts`;
    return this.http.get<Contact[]>(url);
  }

  updateContactsForContractId(
    ContractGuid: string,
    contacts: Contact[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Contracts/${ContractGuid}/contacts`;
    return this.http.put<any>(url, contacts);
  }

  getDocumentsByContractId(ContractGuid: string): Observable<Document[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Contracts/${ContractGuid}/documents`;
    return this.http.get<Document[]>(url);
  }

  addContractDocuments(
    ContractGuid: string,
    documents: Document[]
  ): Observable<Document[]> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Contracts/${ContractGuid}/documents`;
    return this.http.post<Document[]>(url, documents);
  }

  uploadDocument(upload: UploadObject, metadata: any): Subject<void> {
    const url = environment.chiliSauceApiRoot + `/api/Contracts/upload`;

    if (!upload.file) {
      console.warn('no file specified to upload');
      return;
    }

    const subject = new Subject<void>();
    const fileToUpload = upload.file;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    let headers: HttpHeaders = null;
    if (metadata) {
      headers = new HttpHeaders({
        UploadMetadata: JSON.stringify(metadata),
      });
    }

    this.http
      .post(url, formData, {
        reportProgress: true,
        observe: 'events',
        headers: headers,
      })
      .subscribe((event) => {
        if (event.type === HttpEventType.UploadProgress) {
          upload.progress = Math.round((100 * event.loaded) / event.total);
        } else if (event.type === HttpEventType.Response) {
          const response = <BlobResult>event.body;
          upload.url = response.blobAddress;
          subject.next();
          subject.complete();
        }
      });

    return subject;
  }

  getProceduresByContractId(
    contractGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getProceduresByContractId_Filter>
  ): Observable<SmartListResult<ProcedureSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Contracts/${contractGuid}/procedures`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ProcedureSummary>>(url, {
      params: params,
    });
  }

  updateProceduresForContractId(
    contractGuid: string,
    ids: number[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Contracts/${contractGuid}/procedures`;
    return this.http.put<any>(url, ids);
  }

  getFacilitiesByContractId(
    contractGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getFacilitiesByContractId_Filter>
  ): Observable<SmartListResult<FacilitySummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Contracts/${contractGuid}/facilities`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<FacilitySummary>>(url, {
      params: params,
    });
  }

  updateFacilitiesForContractId(
    contractGuid: string,
    ids: string[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Contracts/${contractGuid}/facilities`;
    return this.http.put<any>(url, ids);
  }

  getProvidersByContractId(
    contractGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getProvidersByContractId_Filter>
  ): Observable<SmartListResult<ProviderSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Contracts/${contractGuid}/providers`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ProviderSummary>>(url, {
      params: params,
    });
  }

  updateProvidersForContractId(
    contractGuid: string,
    ids: string[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Contracts/${contractGuid}/providers`;
    return this.http.put<any>(url, ids);
  }

  getAnesthesiasByContractId(
    contractGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getAnesthesiasByContractId_Filter>
  ): Observable<SmartListResult<AnesthesiaSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Contracts/${contractGuid}/anesthesias`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<AnesthesiaSummary>>(url, {
      params: params,
    });
  }

  updateAnesthesiasForContractId(
    contractGuid: string,
    ids: string[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Contracts/${contractGuid}/anesthesias`;
    return this.http.put<any>(url, ids);
  }

  getProviderGroupsByContractId(
    contractGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getProviderGroupsByContractId_Filter>
  ): Observable<SmartListResult<ProviderGroupSummary>> {
    let url =
      environment.chiliSauceApiRoot +
      `/api/Contracts/${contractGuid}/providerGroups`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<ProviderGroupSummary>>(url, {
      params: params,
    });
  }

  updateProviderGroupsForContractId(
    contractGuid: string,
    ids: string[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot +
      `/api/Contracts/${contractGuid}/providerGroups`;
    return this.http.put<any>(url, ids);
  }
}
